export default __webpack_public_path__ + "static/neue-haas-grotesk-text-56-roman-italic-ff3a009ffaa29a75be75e0bcdd873d14.woff";